<p>
	Read also
	<a *ngFor="let page of legalPages" class="link ml-3" routerLink="/{{ page.kebabName }}">{{ page.displayName }}</a>
</p>
